import React, { Component } from 'react';
import { fetchPosts, fetchManual } from '../core/api';
import Carousel from './carousel';
import List from './list';

interface IProps {
  data: string;
}

interface IState {
  elements: any;
}

class App extends Component<IProps, IState> {

  state: IState = { elements: []};
  items:any = [];
  constructor(props: IProps) {
    super(props);
    this.evaluateItems = this.evaluateItems.bind(this);
  }

  componentDidMount() {
    const { data } = this.props;    
    this.evaluateItems(data.split(','));
  }

   async evaluateItems(data) {    
    if (data.length === 0) return;
    const item = data.splice(0, 1)[0];
    console.log(item);
    
    if (!item) return;
    const element = await this.generateItem(item);
    if (!element) return;
    this.items.push(element);
    this.setState({ ...this.state, elements: this.items });
    return this.evaluateItems(data);
  }

  async generateItem(element) {
    const domElement: any = document.getElementById(element) as HTMLDivElement;
    if (!domElement) return null;
    const id: string = element;
    const tags: string = domElement.getAttribute('tags') || '';
    const categories: string = domElement.getAttribute('categories') || '';
    const type: string = domElement.getAttribute('type') || '';
    const total: string = domElement.getAttribute('total') || '';
    const tags_exclude: string = domElement.getAttribute('tags-exclude') || '';
    const categories_exclude: string = domElement.getAttribute('categories-exclude') || '';
    const postType:string = domElement.getAttribute('post-type') || '';
    const feedType:string = domElement.getAttribute('feed-type') || '';
    const postIds:string = domElement.getAttribute('post-ids') || '';

    /** Here generate api string */
    let params;
    let posts;
    if(feedType === 'manual' && postType !== '') {
      params = (postType === 'page')?`/pages/`:`/posts/`;
      params += `?include=${postIds}`;
      posts = await fetchManual(params);
    } else {
      params = ('tags=' + tags + '&categories=' + categories + '&per_page=' + total + '&tags_exclude=' + tags_exclude + '&categories_exclude=' + categories_exclude).replace(/[^=&]+=(&|$)/g, '').replace(/&$/, '');
      posts = await fetchPosts(params);
    }     
   
    return { id, type, params, tags, categories, total, domElement, posts};
  }

  render() {
    const {elements} = this.state;
    return (
      <div className="App">
        {elements.length === 0? <p className="over-solid">Loading...</p>:
        elements
          .map((element, index) => (element.type === 'carousel')
            ? <Carousel data={element} key={index} />
            : <List data={element} key={index} />)
        }
      </div>
    );
  }
}

export default App;
